/**
 * Medical Disclaimers and Safe Wording
 * 
 * GlowLens must be clearly positioned as wellness guidance, not a medical device.
 * This module provides consistent disclaimer text and softens diagnostic language.
 */

export const MEDICAL_DISCLAIMER_SHORT =
  'GlowLens provides wellness guidance only and does not diagnose or treat medical conditions. Always consult a dermatologist or doctor for medical concerns.';

export const MEDICAL_DISCLAIMER_FULL = `GlowLens provides wellness guidance only and does not diagnose or treat medical conditions. Our AI analysis is based on general skincare science and should not replace professional medical advice. Always consult a dermatologist or doctor for medical concerns, especially for persistent or severe skin issues.`;

export const PH_DISCLAIMER =
  'Estimated skin surface pH values are approximate wellness estimates based on image analysis and should not be considered medical measurements.';

/**
 * Soften diagnostic language
 */
export function softenDiagnosticLanguage(text: string): string {
  // Replace harsh diagnostic phrases with softer wellness language
  const replacements: Record<string, string> = {
    'Your skin pH is': 'Estimated skin surface pH:',
    'This will cause acne': 'This may increase the chance of breakouts based on general acne science.',
    'You have': 'Analysis suggests',
    'You are': 'Analysis suggests you may be',
    'Diagnosis:': 'Wellness assessment:',
    'Treatment:': 'Wellness suggestions:',
  };

  let softened = text;
  for (const [harsh, soft] of Object.entries(replacements)) {
    softened = softened.replace(new RegExp(harsh, 'gi'), soft);
  }

  return softened;
}

/**
 * Format pH value with disclaimer
 */
export function formatPHWithDisclaimer(pH: number): string {
  return `Estimated skin surface pH: ${pH.toFixed(1)} (approximate, wellness estimate)`;
}

/**
 * Format acne impact with disclaimer
 */
export function formatAcneImpactWithDisclaimer(impact: string): string {
  return `${impact} based on general acne science. This is a wellness estimate, not a medical diagnosis.`;
}




